import {
  Row,
  Col,
  Card,
  Radio,
  Table,
  Typography,
  // message,
  // Progress,
  Button,
  Avatar,
  Alert,
} from "antd";

// import { DownloadOutlined } from "@ant-design/icons";

import { ToTopOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Investment_message } from "../../assets/Texts";
import axios from "axios";
import { useEffect, useState } from "react";

// Images
import ava1 from "../../assets/images/bitcoin.png";
import ava2 from "../../assets/images/ethereum.png";
import ava3 from "../../assets/images/cardano.png";
import ava4 from "../../assets/images/binancee.png";
import ava5 from "../../assets/images/solana.png";
import ava6 from "../../assets/images/polkadot.png";
// import face from "../../assets/images/face-1.jpg";
// import face2 from "../../assets/images/face-2.jpg";
// import face3 from "../../assets/images/face-3.jpg";
// import face4 from "../../assets/images/face-4.jpg";
// import face5 from "../../assets/images/face-5.jpeg";
// import face6 from "../../assets/images/face-6.jpeg";
// import pencil from "../../assets/images/pencil.svg";
const { Title } = Typography;

// const formProps = {
//   name: "file",
//   action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
//   headers: {
//     authorization: "authorization-text",
//   },
//   onChange(info) {
//     if (info.file.status !== "uploading") {
//       console.log(info.file, info.fileList);
//     }
//     if (info.file.status === "done") {
//       message.success(`${info.file.name} file uploaded successfully`);
//     } else if (info.file.status === "error") {
//       message.error(`${info.file.name} file upload failed.`);
//     }
//   },
// };
// table code start

// project table start
const project = [
  {
    title: "CRYPTOS",
    dataIndex: "name",
    width: "32%",
  },
  {
    title: "PROJECTIONS",
    dataIndex: "age",
  },
  {
    title: "CURRENT PRICE",
    dataIndex: "address",
  },
  {
    title: "24 Hours",
    dataIndex: "completion",
  },
];

function InvestmentInfo() {
  // const onChange = (e) => console.log(`radio checked:${e.target.value}`);

  const [cryptos, setCryptos] = useState([]);

  // const interval = 0;
  // const [BtcPrice, setBtcPrice] = useState(0);

  let getprice = (array, coin_name) => {
    // console.log(array);
    let new_array = array.filter(({ name }) => name === coin_name);
    if (new_array.length > 0) {
      // console.log(new_array[0].current_price);
      return new_array[0].current_price;
    }
    // console.log(new_array);
    return 0;
  };
  let getchange = (array, coin_name) => {
    // console.log(array);
    let new_array = array.filter(({ name }) => name === coin_name);
    if (new_array.length > 0) {
      // console.log(new_array[0].current_price);
      // console.log(new_array[0].price_change_24h);
      return new_array[0].price_change_percentage_24h_in_currency.toFixed(3);
    }
    // console.log(new_array);
    return 0;
  };

  let getcolor = (change) => {
    if (change < 0) {
      return "danger";
    } else {
      if (change === 0) {
        return "normal";
      } else {
        return "success";
      }
    }
  };

  const getCryptos = () => {
    axios
      .get(
        "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=20&page=1&sparkline=false&price_change_percentage=24h"
      )
      .then((res) => {
        setCryptos(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  useEffect(() => {
    // console.log(cryptos);
    getCryptos();
    const interval = setInterval(() => {
      getCryptos();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const dataproject = [
    {
      key: "1",

      name: (
        <>
          <Avatar.Group>
            <Avatar className="shape-avatar" src={ava1} size={25} alt="" />
            <div className="avatar-info">
              <Title level={5}>Bitcoin</Title>
            </div>
          </Avatar.Group>
        </>
      ),
      age: (
        <>
          <div className="semibold">$89000</div>
        </>
      ),
      address: (
        <>
          <div className="semibold">{`$${getprice(cryptos, "Bitcoin")}`}</div>
        </>
      ),
      completion: (
        <>
          <div className="ant-progress-project">
            <Title level={5} type={getcolor(getchange(cryptos, "Bitcoin"))}>
              {getchange(cryptos, "Bitcoin")}
            </Title>
            <div style={{ marginLeft: 10 }}>
              <span>
                <Link to="/sign-in">
                  <Button size="small">select</Button>
                </Link>
              </span>
            </div>
          </div>
        </>
      ),
    },

    {
      key: "2",
      name: (
        <>
          <Avatar.Group>
            <Avatar className="shape-avatar" src={ava2} size={25} alt="" />
            <div className="avatar-info">
              <Title level={5}>Ethereum</Title>
            </div>
          </Avatar.Group>
        </>
      ),
      age: (
        <>
          <div className="semibold">$8600</div>
        </>
      ),
      address: (
        <>
          <div className="semibold">{`$${getprice(cryptos, "Ethereum")}`}</div>
        </>
      ),
      completion: (
        <>
          <div className="ant-progress-project">
            <Title level={5} type={getcolor(getchange(cryptos, "Ethereum"))}>
              {getchange(cryptos, "Ethereum")}
            </Title>
            <div style={{ marginLeft: 10 }}>
              <span>
                <Link to="/sign-in">
                  <Button>select</Button>
                </Link>
              </span>
            </div>
          </div>
        </>
      ),
    },

    {
      key: "3",
      name: (
        <>
          <Avatar.Group>
            <Avatar className="shape-avatar" src={ava3} size={25} alt="" />
            <div className="avatar-info">
              <Title level={5}> Cardano</Title>
            </div>
          </Avatar.Group>
        </>
      ),
      age: (
        <>
          <div className="semibold">$7.4</div>
        </>
      ),
      address: (
        <>
          <div className="semibold">{`$${getprice(cryptos, "Cardano")}`}</div>
        </>
      ),
      completion: (
        <>
          <div className="ant-progress-project">
            <Title level={5} type={getcolor(getchange(cryptos, "Cardano"))}>
              {getchange(cryptos, "Cardano")}
            </Title>
            <div style={{ marginLeft: 10 }}>
              <span>
                <Link to="/sign-in">
                  <Button>select</Button>
                </Link>
              </span>
            </div>
          </div>
        </>
      ),
    },

    {
      key: "4",
      name: (
        <>
          <Avatar.Group>
            <Avatar className="shape-avatar" src={ava4} size={25} alt="" />
            <div className="avatar-info">
              <Title level={5}> Binance</Title>
            </div>
          </Avatar.Group>
        </>
      ),
      age: (
        <>
          <div className="semibold">$920</div>
        </>
      ),
      address: (
        <>
          <div className="semibold">{`$${getprice(
            cryptos,
            "Binance Coin"
          )}`}</div>
        </>
      ),
      completion: (
        <>
          <div className="ant-progress-project">
            <Title
              level={5}
              type={getcolor(getchange(cryptos, "Binance Coin"))}
            >
              {getchange(cryptos, "Binance Coin")}
            </Title>
            <div style={{ marginLeft: 10 }}>
              <span>
                <Link to="/sign-in">
                  <Button>select</Button>
                </Link>
              </span>
            </div>
          </div>
        </>
      ),
    },

    {
      key: "5",
      name: (
        <>
          <Avatar.Group>
            <Avatar className="shape-avatar" src={ava5} size={25} alt="" />
            <div className="avatar-info">
              <Title level={5}>Solana</Title>
            </div>
          </Avatar.Group>
        </>
      ),
      age: (
        <>
          <div className="semibold">$400</div>
        </>
      ),
      address: (
        <>
          <div className="semibold">{`$${getprice(cryptos, "Solana")}`}</div>
        </>
      ),
      completion: (
        <>
          <div className="ant-progress-project">
            <Title level={5} type={getcolor(getchange(cryptos, "Solana"))}>
              {getchange(cryptos, "Solana")}
            </Title>
            <div style={{ marginLeft: 10 }}>
              <span>
                <Link to="/sign-in">
                  <Button>select</Button>
                </Link>
              </span>
            </div>
          </div>
        </>
      ),
    },

    {
      key: "6",
      name: (
        <>
          <Avatar.Group>
            <Avatar className="shape-avatar" src={ava6} size={25} alt="" />
            <div className="avatar-info">
              <Title level={5}>Polkadot</Title>
            </div>
          </Avatar.Group>
        </>
      ),
      age: (
        <>
          <div className="semibold">$89</div>
        </>
      ),
      address: (
        <>
          <div className="semibold">{`$${getprice(cryptos, "Polkadot")}`}</div>
        </>
      ),
      completion: (
        <>
          <div className="ant-progress-project">
            <Title level={5} type={getcolor(getchange(cryptos, "Polkadot"))}>
              {getchange(cryptos, "Polkadot")}
            </Title>
            <div style={{ marginLeft: 10 }}>
              <span>
                <Link to="/sign-in">
                  <Button>select</Button>
                </Link>
              </span>
            </div>
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <Alert
        message="About Investments"
        description={Investment_message}
        type="info"
        showIcon
        closable
      />
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="projects"
              extra={
                <>
                  <Radio.Group defaultValue="all">
                    <Radio.Button value="store">ALL</Radio.Button>
                  </Radio.Group>
                </>
              }
            >
              <div className="table-responsive">
                <Table
                  columns={project}
                  dataSource={dataproject}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
              <div className="uploadfile pb-15 shadow-none">
                {/* <Upload {...formProps}> */}
                <Button
                  type="dashed"
                  className="ant-full-box"
                  icon={<ToTopOutlined />}
                >
                  Suggest a Project
                </Button>
                {/* </Upload> */}
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default InvestmentInfo;
